/**
 * Mobile node width in pixels - narrower for mobile devices
 */
export const MOBILE_NODE_WIDTH_PX = 180;
